// Guarda no navegador (localStorage) o progresso de um pedido do wizard, pra
// pessoa poder sair no meio e continuar depois de onde parou. Um rascunho por
// pessoa + pedido. Anexos (File) não entram: não sobrevivem ao JSON, e a
// pessoa só precisa selecioná-los de novo na etapa de Documentos.
//
// Tudo aqui é best-effort: localStorage pode estar cheio, bloqueado (modo
// privado) ou com lixo — nesses casos o wizard só deixa de oferecer a retomada.
import logger from '../../../../utils/logger';
import { protocoloService } from '../../../../services';

const PREFIXO = 'rascunhos_pedido_v1:';
// Rascunho mais antigo que isso é descartado — evita guardar dados pessoais
// indefinidamente e retomar pedidos que a pessoa já esqueceu.
const VALIDADE_MS = 7 * 24 * 60 * 60 * 1000;

const chaveStorage = (pessoaId) => `${PREFIXO}${pessoaId}`;
const chavePedido = (departamentoId, pedidoId) => `${departamentoId}/${pedidoId}`;

const lerTodos = (pessoaId) => {
  if (!pessoaId) return {};
  try {
    const bruto = localStorage.getItem(chaveStorage(pessoaId));
    const todos = bruto ? JSON.parse(bruto) : {};
    const agora = Date.now();

    // Já aproveita a leitura pra varrer os vencidos.
    const validos = Object.fromEntries(
      Object.entries(todos).filter(([, r]) => r && agora - r.salvoEm < VALIDADE_MS)
    );
    if (Object.keys(validos).length !== Object.keys(todos).length) gravarTodos(pessoaId, validos);
    return validos;
  } catch (err) {
    logger.warn('Não foi possível ler os rascunhos de pedido:', err.message);
    return {};
  }
};

const gravarTodos = (pessoaId, todos) => {
  try {
    if (Object.keys(todos).length === 0) {
      localStorage.removeItem(chaveStorage(pessoaId));
    } else {
      localStorage.setItem(chaveStorage(pessoaId), JSON.stringify(todos));
    }
  } catch (err) {
    logger.warn('Não foi possível gravar os rascunhos de pedido:', err.message);
  }
};

/**
 * pessoaId que identifica de quem é o rascunho — mesma origem (token/usuário)
 * usada no resto da integração de Protocolo. Devolve null em vez de lançar,
 * já que é chamado durante a renderização.
 */
export const getPessoaIdRascunho = (user) => {
  try {
    return protocoloService.extrairIdsUsuario(user).pessoaId;
  } catch {
    return null;
  }
};

export const obterRascunho = (pessoaId, departamentoId, pedidoId) =>
  lerTodos(pessoaId)[chavePedido(departamentoId, pedidoId)] || null;

export const salvarRascunho = (pessoaId, rascunho) => {
  if (!pessoaId) return;
  const todos = lerTodos(pessoaId);
  todos[chavePedido(rascunho.departamentoId, rascunho.pedidoId)] = { ...rascunho, salvoEm: Date.now() };
  gravarTodos(pessoaId, todos);
};

export const removerRascunho = (pessoaId, departamentoId, pedidoId) => {
  const todos = lerTodos(pessoaId);
  const chave = chavePedido(departamentoId, pedidoId);
  if (!(chave in todos)) return;
  delete todos[chave];
  gravarTodos(pessoaId, todos);
};

/** Rascunho já vinculado a um requerimento criado na API (usado por Minhas Solicitações). */
export const obterRascunhoPorRequerimento = (pessoaId, requerimentoId) => {
  if (!requerimentoId) return null;
  return Object.values(lerTodos(pessoaId)).find(r => String(r.requerimentoId) === String(requerimentoId)) || null;
};

export const removerRascunhoPorRequerimento = (pessoaId, requerimentoId) => {
  const rascunho = obterRascunhoPorRequerimento(pessoaId, requerimentoId);
  if (rascunho) removerRascunho(pessoaId, rascunho.departamentoId, rascunho.pedidoId);
};
